import tables from './tables';
import utils from '../utils';

const getDiscoverViewById = async (id, token) => {
  const { data, success, message } = await utils.getFromMikMakFirebaseService(
    `getById/${tables.discoverViews}/${id}`,
    token,
  );

  if (!success) throw new Error(message);

  return data;
};

const setDiscoverView = async (viewData, token) => {
  const { id } = viewData;

  try {
    await utils.postToMikMakFirebaseService(`set/${tables.discoverViews}/${id}`, viewData, token);
  } catch (err) {
    throw `Error creating discoverView - ${err}`;
  }
};

const getDiscoverProductsByBrandId = async (brandId, token) => {
  const { data, success } = await utils.getFromMikMakFirebaseService(
    `getBrandProductFeed/${brandId}`,
    token,
  );

  if (!success) throw new Error(data);

  return data;
};

const getDiscoverProductById = async (productId, token) => {
  const { data, success } = await utils.getFromMikMakFirebaseService(
    `getById/${tables.brandProductFeed}/${productId}`,
    token,
  );

  if (!success) throw new Error(data);

  return data;
};

const getDiscoverViewsByBrandId = async (brandId, token) => {
  if (!brandId) { throw 'Error fetching discover views - no brand specified'; }

  const { data, success } = await utils.getFromMikMakFirebaseService(
    `get/${tables.discoverViews}?orderBy=brandId&equalTo=${brandId}`,
    token,
  );

  if (!success) throw new Error(data);

  return data;
};

const updateDiscoverView = async (id, viewData, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `update/${tables.discoverViews}/${id}`,
      viewData,
      token,
    );
  } catch (err) {
    throw `Error updating discoverView - ${err}`;
  }
};

const updateProductFeed = async (id, feedData, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `update/${tables.brandProductFeed}/${id}`,
      feedData,
      token,
    );
  } catch (err) {
    throw `Error updating brand product feed - ${err}`;
  }
};

export default {
  getDiscoverViewById,
  setDiscoverView,
  getDiscoverProductById,
  getDiscoverProductsByBrandId,
  getDiscoverViewsByBrandId,
  updateDiscoverView,
  updateProductFeed,
};
